import React from 'react';
import './MeetingSeriesScopeSelector.scss';

export interface MeetingSeriesScopeSelectorProps {
    name: string;
    applyToFollowing: boolean;
    onChange: (applyToFollowing: boolean) => void;
}

const SCOPE_OPTIONS = [
    { applyToFollowing: false, key: 'this', label: 'This meeting' },
    {
        applyToFollowing: true,
        key: 'following',
        label: 'This and all following meetings',
    },
];

export const MeetingSeriesScopeSelector = (
    props: MeetingSeriesScopeSelectorProps
) => {
    return (
        <div className="meeting-series-scope-selector">
            {SCOPE_OPTIONS.map((option) => {
                const optionId = `${props.name}-${option.key}`;
                return (
                    <div key={optionId} className="modal_body_radio">
                        <input
                            type="radio"
                            id={optionId}
                            name={props.name}
                            checked={
                                props.applyToFollowing ===
                                option.applyToFollowing
                            }
                            onChange={() =>
                                props.onChange(option.applyToFollowing)
                            }
                        />
                        <label htmlFor={optionId}>{option.label}</label>
                    </div>
                );
            })}
        </div>
    );
};
